var map = {
	"./realisation-ball.png": 54105,
	"./realisation-cancelled-ball.png": 92167,
	"./realisation-cancelled-teardrop.png": 60891,
	"./realisation-cancelled.png": 54277,
	"./realisation-completed-ball.png": 73097,
	"./realisation-completed.png": 37191,
	"./realisation-connected-ball.png": 61099,
	"./realisation-connected-teardrop.png": 66351,
	"./realisation-connected.png": 88089,
	"./realisation-onhold-ball.png": 79182,
	"./realisation-onhold-teardrop.png": 47290,
	"./realisation-onhold.png": 86054,
	"./realisation-teardrop.png": 42461
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35017;